import { inventoryItemIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const getBinInventoryForFulfillment = {
  name: "getBinInventoryForFulfillment" as const,
  input: z.object({
    storageLocationIds: z.array(storageLocationIdFormat.schema).min(1),
  }),
  output: z.object({
    lines: z.array(
      z.object({
        productId: productIdFormat.schema,
        inventoryItemId: inventoryItemIdFormat.schema.nullable(),
        sku: z.string().nullable(),
        title: z.string(),
        lotNumber: z.string().nullable(),
        expirationDate: z.coerce.date().nullable(),
        sources: z.array(
          z.object({
            storageLocationId: storageLocationIdFormat.schema,
            binName: z.string(),
            available: z.number(),
          }),
        ),
      }),
    ),
  }),
};
